import { BASE_URL } from '../../../shared/consts/variables';

const parseResponse = async (response: Response) => {
    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.error || data.message || 'Erro ao processar solicitação');
    }

    return data;
};

export const requestPasswordResetCode = async (email: string) => {
    const response = await fetch(`${BASE_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
    });

    return parseResponse(response);
};

export const resetPasswordWithCode = async (
    email: string,
    code: string,
    newPassword: string
) => {
    const response = await fetch(`${BASE_URL}/auth/reset-password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, newPassword }),
    });

    return parseResponse(response);
};
